import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { MobileSelectTheme } from '../../../theme/default-theme';
import { IProductSortingDropdownTranslations } from './ProductSortingDropdown';
import { translate } from '@estee/elc-service';

export interface IMobileSortingDropdown {
    productSortingDropdownValue: string;
    setProductSortingDropdownValue(inputName: string, value: string): void;
    optionsArray: {
        label: string;
        value: string;
    }[];
    translations?: IProductSortingDropdownTranslations;
}

const MobileSelect = styled.select`
    position: relative;
    width: 100%;
    height: ${ContentSpacing.space40};
    padding-left: ${ContentSpacing.space10};
    appearance: none;
    ${MobileSelectTheme};

    [dir='rtl'] & {
        padding-left: 0;
        padding-right: ${ContentSpacing.space10};
    }
`;

export const MobileSortingDropdown = translate(['sortByLabel'])(
    observer(function MobileSortingDropdown(props: IMobileSortingDropdown) {
        const { sortByLabel } = props.translations as IProductSortingDropdownTranslations;

        const onSelectValue = (event: React.ChangeEvent<HTMLSelectElement>) => {
            props.setProductSortingDropdownValue(
                event.currentTarget.name,
                event.currentTarget.value
            );
        };

        const mobileSortOptions = props.optionsArray.map((option, key) => (
            <option key={`${key}-${option.value}`} value={option.value} aria-label={option.label}>
                {option.label}
            </option>
        ));

        return (
            <label data-test-id="sort_by" aria-label={sortByLabel}>
                <MobileSelect value={props.productSortingDropdownValue} onChange={onSelectValue}>
                    {mobileSortOptions}
                </MobileSelect>
            </label>
        );
    })
);
